import React from "react";
import { ReactElement } from "react";

import Carousel from "../Carousel";
import { listUrl } from "../Data";
import PillarsWrapper from '../PillarsWrapper';

const PillarsCarousel = (): ReactElement => {
  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 1.2,
    slidesToScroll: 1,
    initialSlide: 0,

  };

  const products = listUrl.pillars.products

  return (
    <Carousel settings={settings}>
      {products && products.map(product => (
        <PillarsWrapper icon={product.icon} title={product.title} subtitle={product.subtitle} key={product.title} />
      ))}
    </Carousel>
  );
};

export default PillarsCarousel;
